import React from 'react'

// config and utils
import constants from 'config/constants'
import l from 'config/localization'
import logos from 'utils/logos'

// assets and styles
import {
  PeopleFill as People,
  EnvelopeOpenFill as Rsvp,
  VectorPen as Pen
} from '@styled-icons/bootstrap'

import {
  DashboardSideNavOuter,
  FooterLink,
  OrgWrapper,
  OrgDetails,
  OrgName,
  Logo,
  NavItems,
  BrowniePointsLogo,
  LogoWrapper,
  SidebarFooterLogoWrapper
} from './styles'

import { ReactComponent as OppIcon } from 'assets/images/svgs/icon-org-page-opportunity.svg'
import { ReactComponent as OrgIcon } from 'assets/images/svgs/icon-org-page-organisation.svg'
import { ReactComponent as EmailActivityIcon } from 'assets/images/svgs/icon-email-activity.svg'

import { PatchQuestionFill } from '@styled-icons/bootstrap/PatchQuestionFill'
import { Googlescholar } from '@styled-icons/simple-icons'
import { DashboardSideNav, DashboardNavItem } from '../Dashboard'
import { Location } from '@styled-icons/entypo'
import { PersonMoney } from '@styled-icons/fluentui-system-filled/PersonMoney'
import { Books } from '@styled-icons/icomoon'
import { PersonWorkspace } from '@styled-icons/bootstrap/PersonWorkspace'
import { Dashboard } from '@styled-icons/boxicons-solid'
const userIcon = 'https://cdn.browniepoints.africa/assets/bpimg_hkk3to4hxef989p.png'

// Load components synchronously
import ConditionalDisplay from 'components/ConditionalDisplay/ConditionalDisplay'

const { dashSidebarLogo } = logos
const orgRoleable = constants.ROLEABLES.ORG
const superAdmin = constants.ROLES.SUPERADMIN

const copyLink = ({ user }) => {
  if (!user) return null

  navigator.clipboard.writeText(window.location.origin + `/dashboard/people?s=${user.email}`)
}

const DashboardSidebar = ({
  displayBpNavbar,
  displayFormBar,
  displayGsHeader,
  locationInfo,
  roles = [],
  user = {}
}) => {
  if (displayFormBar) return null
  if (!displayGsHeader && !displayBpNavbar) return null

  const hasGodRole = roles.some(r => r.role_type === constants.ROLES.GOD_MODE)
  const isSuperAdmin = roles.some(r => r.roleable === orgRoleable && r.role_type === superAdmin)
  const isGodOrSuperAdmin = hasGodRole || isSuperAdmin

  const userAvatar = user.avatar_url || userIcon
  const displayName = user.f_name

  return (
    <DashboardSideNavOuter displayMobile={locationInfo.homeActive}>
      <DashboardSideNav displayMobile={locationInfo.homeActive}>
        <OrgWrapper marginBottom={hasGodRole ? '20px' : '50px'}>
          <LogoWrapper>
            <Logo src={userAvatar} />
          </LogoWrapper>

          <OrgDetails>
            <OrgName onClick={() => copyLink({ user })}>{displayName}</OrgName>
          </OrgDetails>
        </OrgWrapper>

        <NavItems id="dashboard-menu-items-wrapper" displayMobile={locationInfo.homeActive}>
          <DashboardNavItem
            label="Dashboard"
            Icon={Dashboard}
            to="/dashboard"
            isActive={locationInfo.homeActive}
            id={locationInfo.homeActive ? 'active-dash-nav-item' : undefined}
          />

          <ConditionalDisplay displayWhen={[hasGodRole]}>
            <DashboardNavItem
              label="Email activity"
              Icon={EmailActivityIcon}
              to={`/dashboard/email-activity?year=${constants.CURRENT_YEAR}`}
              isActive={locationInfo.emailActivityPathActive}
              id={locationInfo.emailActivityPathActive ? 'active-dash-nav-item' : undefined}
            />

            <DashboardNavItem
              label={`Provinces`}
              Icon={Location}
              to={`/dashboard/${l('ROUTE_CAMPS')}?comptype=provincial`}
              isActive={locationInfo.provCampaignsActive}
              id={locationInfo.provCampaignsActive ? 'active-dash-nav-item' : undefined}
            />

            <DashboardNavItem
              label={`Subjects`}
              Icon={Books}
              to={`/dashboard/${l('ROUTE_CAMPS')}?comptype=subject`}
              isActive={locationInfo.subjCampaignsActive}
              id={locationInfo.subjCampaignsActive ? 'active-dash-nav-item' : undefined}
            />

            <DashboardNavItem
              label={'Rounds'}
              Icon={OppIcon}
              to={`/dashboard/rounds`}
              isActive={locationInfo.opportunitiesActive}
              id={locationInfo.opportunitiesActive ? 'active-dash-nav-item' : undefined}
            />

            <DashboardNavItem
              label={'Workshops'}
              Icon={PersonWorkspace}
              to={`/dashboard/workshops`}
              isActive={locationInfo.opportunitiesActive}
              id={locationInfo.opportunitiesActive ? 'active-dash-nav-item' : undefined}
            />

            <DashboardNavItem
              label={'Schools'}
              Icon={OrgIcon}
              to={`/dashboard/${l('ROUTE_ORGS')}`}
              isActive={locationInfo.organisationsActive}
              id={locationInfo.organisationsActive ? 'active-dash-nav-item' : undefined}
            />

            <DashboardNavItem
              label={'Institutions'}
              Icon={OrgIcon}
              to={`/dashboard/institutions`}
              isActive={locationInfo.institutionsActive}
              id={locationInfo.institutionsActive ? 'active-dash-nav-item' : undefined}
            />
          </ConditionalDisplay>

          <ConditionalDisplay displayWhen={[isGodOrSuperAdmin]}>
            <DashboardNavItem
              label="People"
              Icon={People}
              to={'/dashboard/people'}
              isActive={locationInfo.peopleActive}
              id={locationInfo.peopleActive ? 'active-dash-nav-item' : undefined}
            />

            <DashboardNavItem
              label={`Scholarships`}
              Icon={PersonMoney}
              to={`/dashboard/scholarships`}
              isActive={locationInfo.scholarshipsActive}
              id={locationInfo.scholarshipsActive ? 'active-dash-nav-item' : undefined}
            />
          </ConditionalDisplay>

          <DashboardNavItem
            label="RSVPs"
            Icon={Rsvp}
            to={'/dashboard/rsvps'}
            isActive={locationInfo.rsvpsActive}
            id={locationInfo.rsvpsActive ? 'active-dash-nav-item' : undefined}
          />

          <DashboardNavItem
            label="Learners"
            Icon={Googlescholar}
            to={'/dashboard/enrolments'}
            isActive={locationInfo.enrolmentsActive}
            id={locationInfo.enrolmentsActive ? 'active-dash-nav-item' : undefined}
          />

          <DashboardNavItem
            label="Registrations"
            Icon={Pen}
            to={'/dashboard/registrations'}
            isActive={locationInfo.registrationsActive}
            id={locationInfo.registrationsActive ? 'active-dash-nav-item' : undefined}
          />

          <DashboardNavItem label="Helpdesk" Icon={PatchQuestionFill} to={'/docs'} />
        </NavItems>
      </DashboardSideNav>

      <SidebarFooterLogoWrapper>
        <FooterLink to="/">
          <BrowniePointsLogo src={dashSidebarLogo} />
        </FooterLink>
      </SidebarFooterLogoWrapper>
    </DashboardSideNavOuter>
  )
}

export default DashboardSidebar
